import { Link } from "react-router";
import { OtdLogo } from "@/components/layout/otd-logo";

export function BrandMark() {
	return (
		<Link to="/" className="brand-mark">
			<OtdLogo className="brand-mark__logo" />
			<span className="brand-mark__text">
				<span className="brand-mark__name">Obra Todo Dia</span>
				<span className="brand-mark__tagline">Diário inteligente</span>
			</span>
		</Link>
	);
}
